var map = {
	"./asidebuilding.png": 7695,
	"./bb1.png": 6794,
	"./bb2.png": 1025,
	"./bb3.png": 9896,
	"./bb4.png": 8887,
	"./direktor.png": 3183,
	"./ilmiy_kengash.png": 3427,
	"./kasbiy_talim.png": 1366,
	"./laptop.png": 2755,
	"./maktabgacha.png": 2471,
	"./oquv-metodik_komplekslar1.png": 4991,
	"./oquv-metodik_komplekslar2.png": 3364,
	"./orinbosar1.png": 8675,
	"./orinbosar2.png": 6696,
	"./prezident.png": 9980,
	"./pucheon_futurefest.png": 629,
	"./sorovnoma.png": 3007,
	"./xorazmda.png": 1154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3503;